import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  tableGrid: {
    backgroundColor: theme.palette.background.white,
    padding: "10px 20px",
    borderRadius: 10,
    marginBottom: 25,
    boxShadow: theme.palette.boxShadow.main,
  },
  tableGridSimple: {
    
    padding: "0px 0px",
    borderRadius: 0,
    marginBottom: 0
  },
}));